var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalSucc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2468_759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4673 48.9344C32.6532 48.9344 31.9295 48.5725 31.4773 48.0299L17.819 33.1957C16.824 32.1103 16.9145 30.3916 17.9999 29.3967C19.0852 28.4017 20.8039 28.4922 21.7989 29.5776L33.5577 42.3313L66.1206 9.85894C67.2059 8.77358 68.9246 8.77358 69.9196 9.85894C70.9146 10.9443 71.0049 12.663 69.9196 13.658L35.3669 48.1203C34.9145 48.6631 34.191 48.9344 33.4673 48.9344Z",
    fill: "#2EBD04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 72C16.1909 72 0 55.8091 0 36.0001C0 16.1911 16.1909 0 36.0001 0C37.5378 0 38.7136 1.17591 38.7136 2.71349C38.7136 4.25107 37.5377 5.42698 36.0001 5.42698C19.1759 5.42698 5.42715 19.1757 5.42715 35.9999C5.42715 52.8241 19.1759 66.5729 36.0001 66.5729C52.8243 66.5729 66.573 52.8241 66.573 35.9999C66.573 34.4622 67.7489 33.2864 69.2865 33.2864C70.8241 33.2864 72 34.4623 72 35.9999C72 55.8091 55.8091 72 36.0001 72Z",
    fill: "#19295C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2468_759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalSucc);
export default __webpack_public_path__ + "static/media/ModalSucc.8521e197a3d77e93902944f2a2a06580.svg";
export { ForwardRef as ReactComponent };